import SidebarBookingsPriceController from 'uplisting-frontend/pods/-sidebar/bookings/price/controller';

export default class ProtectionOverviewBookingsPriceController extends SidebarBookingsPriceController {}
